import { render, staticRenderFns } from "./PsoriasisReportPhaseV2.vue?vue&type=template&id=44d71d36&scoped=true&"
import script from "./PsoriasisReportPhaseV2.vue?vue&type=script&lang=js&"
export * from "./PsoriasisReportPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisReportPhaseV2.vue?vue&type=style&index=0&id=44d71d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d71d36",
  null
  
)

export default component.exports